import { useState } from 'preact/hooks';
import { useApp } from '../context';
import { net } from '../state';
import { Button } from './Button';

/** Invite code field: joins a (private) room by its code. */
export function JoinCode() {
  const app = useApp();
  const [code, setCode] = useState('');
  const online = net.value.status === 'online';
  const clean = code.trim().toUpperCase();
  const join = () => clean && app.joinRoom({ code: clean });
  return (
    <form
      class="join-code"
      onSubmit={(e) => {
        e.preventDefault();
        join();
      }}
    >
      <input
        class="input mono"
        value={code}
        maxLength={8}
        placeholder="Invite code"
        aria-label="Invite code"
        spellcheck={false}
        autocomplete="off"
        onInput={(e) => setCode((e.currentTarget as HTMLInputElement).value.toUpperCase())}
      />
      <Button variant="secondary" type="submit" disabled={!online || clean.length < 4}>
        Join
      </Button>
    </form>
  );
}
